import React from 'react';
import className from 'classnames';
import moment from 'moment';
import {get} from 'lodash';
import axios from 'axios';

import {
  CSRF_TOKEN,
  requestCallback,
} from '../lib/helpers';

import {
  useCheckIds,
  useModal,
} from '../hooks';

import TableHeader from './TableHeader';
import Modal from './Modal'
import ModalDelete from './ModalDelete';
import RegisteredUuidFormModal from './RegisteredUuidFormModal';

const RegisteredUuidsList = ({
  registeredUuids = [],
  total = 0,
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Registered UUIDs list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} registered</p>
        </div>

        <div className='MainHeader__right'>
          <RegisteredUuidFormModal
            klassName='MainHeader__right__a MainHeader__right__a--bright-blue'
            label='Register UUID'
            title='Register UUID'
            reload
          />
        </div>
      </div>

      <div className='Table Table--registered-uuids-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'ID',
              sortKey: 'id',
            },
            {
              label: 'UUID'
            },
            {
              label: 'Registered Count'
            },
            {
              label: 'Created at'
            },
            {
              label: 'Manage',
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {registeredUuids.map((registeredUuid) => (
          <div
            className='Table__row'
            key={`${registeredUuid.id}_${registeredUuid.createdAt}`}
            data-x={registeredUuid}
          >
            <div className='Table__col'>{registeredUuid.id}</div>
            <div className='Table__col'>
              <a
                className='Table__a'
                href={`/${gon.currentProvider}/users/search?query[keyword]=${registeredUuid.uuid}`}
              >
                {registeredUuid.uuid}
              </a>
            </div>

            <div className='Table__col'>{registeredUuid.usersCount}</div>

            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: registeredUuid.createdAt !== null ?
                    moment(registeredUuid.createdAt).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div className='Table__col'>
              <div className='Table__controls'>
                <RegisteredUuidFormModal
                  klassName='Table__controls__a Table__controls__a--pencil'
                  title='Edit Registered Uuid'
                  registeredUuid={registeredUuid}
                  reload
                />
                <ModalDelete
                  type='registered_uuid'
                  id={get(registeredUuid, 'id')}
                  klassName='Table__controls__a Table__controls__a--trash'
                  reload
                  hideText
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default RegisteredUuidsList
